import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Typography, Divider } from "antd";
import { getServiceExpenseVoucherDetailsApi } from "../../../../../apiservice/service";
import { numberFormat, convertNumberToWords, formatToCompanyTimezone, numberFormatTax } from "../../../../../lib/functions";
import "./voucher-mobile.css"
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../../../Auth/authSelectors";

const { Title, Text } = Typography;

const ServiceExpenseVoucherBody = ({ service_ex_id, institution, printMode = false, showStamp = false, showSignature = false, showShipping = false, setVoucherNo, setAccName, setCustomerEmail }) => {
  const [data, setData] = useState(null);

  const authInfo = useSelector(selectAuthInfo);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const isIndiaGst = authInfo?.gst_enabled === "yes";
  const taxLabel = isIndia ? "GST" : "VAT";
  const isGSTDisabled =
    isIndia && authInfo?.gst_enabled == "no";

  useEffect(() => {
    if (!service_ex_id) return;
    getServiceExpenseVoucherDetailsApi({ service_ex_id, from: "voucher" }).then((res) => {
      if (res?.data?.length) {
        const record = res.data[0];
        setData(record);
        // important guard for printMode
        if (!printMode && setVoucherNo) {
          setVoucherNo(record.service_ex_voucher_no);
          setAccName(record.acc_name);
        }

        if (record.email_address) {
          setCustomerEmail?.(record.email_address);
        }
      }
    });
  }, [service_ex_id]);

  if (!data) return null;

  const isIndividual = data.is_cal_type === "individual";
  const items = (data.details || []).map(item => ({
    ...item,
    qty_display:
      item?.item_qty +
      " " +
      item?.unit_symbol +
      (item?.conversion > 1
        ? ", " + item?.retail_qty + " " + item?.base_unit_name
        : ""),
    // done_qty_display :
    //           item?.done_item_qty +
    //           " " +
    //           item?.unit_symbol +
    //           (item?.conversion > 1
    //             ? ", " + item?.done_retail_qty + " " + item?.base_unit_name
    //             : ""),
  }))



  // calculate grand total
  const grandTotal = isIndividual
    ? items.reduce((sum, d) => {
      let qty = d.item_qty || d.pur_o_qty || 0;
      let rate = Number(d.item_rate || 0);
      let total = qty * rate;
      total -= (Number(d.item_discount_per) / 100) * total;
      total += (Number(d.item_tax_per) / 100) * total;
      return sum + total;
    }, 0)
    : data?.total_amount || 0;

  const columns = isIndividual
    ? [
      { title: "#", render: (_, __, i) => i + 1, width: 40 },
      { title: "Item Name", dataIndex: "item_name" },
      {
        title: "Rate",
        dataIndex: "item_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 50
      },
      { title: "Per", dataIndex: "unit_name", align: "right", width: 70 },
      { title: "Quantity", dataIndex: "item_qty", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, ""), width: 80 },
      { title: "Disct%", dataIndex: "item_discount_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, ""), width: 75 },
      ...(!isGSTDisabled
        ? [
          { title: `${taxLabel}% `, dataIndex: "item_tax_per", align: "right", render: (v) => Number(v).toFixed(2).replace(/\.00$/, ""), width: 70 },
        ]
        : []),

      {
        title: "Total",
        align: "right",
        render: (_, d) => {
          let qty = d.item_qty || d.item_qty || 0;
          let rate = Number(d.item_rate || 0);
          let total = qty * rate;
          total -= (Number(d.item_discount_per) / 100) * total;
          total += (Number(d.item_tax_per) / 100) * total;
          return total.toFixed(2);
        },
        width: 90
      },
    ]
    : [
      { title: "#", render: (_, __, i) => i + 1, width: 40 },
      { title: "Item Name", dataIndex: "item_name" },
      {
        title: "Rate",
        dataIndex: "item_rate",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 70
      },
      { title: "Per", dataIndex: "per_unit_symbol", align: "right", width: 70 },
      { title: "Quantity", dataIndex: "qty_display", align: "right", width: 110 },
      // { title: "Sold Quantity", dataIndex: "done_qty_display", align: "right" },
      {
        title: "Amount",
        dataIndex: "item_total",
        align: "right",
        render: (v) => Number(v).toFixed(2),
        width: 90
      },
    ];

  return (
    <div className="voucher-section invoice-v2">
      {/* Header */}

      <Row justify="space-between" style={{ marginBottom: 16 }}>

        <Col flex="0 0 320px" className="bill-to" style={{ marginTop: "58px" }}>
          <Text strong>Supplier/ Creditor Code: &nbsp;{data.acc_code}</Text>
          <br />
          <Text strong>Name: &nbsp;{data.acc_name}</Text>
          {/* <br />
          <Text >Institution: &nbsp;{data.institution_name}</Text> */}
          <br />
          <Text className="wrap-text">Address: &nbsp; {data.address}</Text>

          <Text>Contact No: &nbsp; +{data.contact_no}</Text>

          {showShipping && data.shipping_address && (
            <>
              <br />
              <br />
              <Text strong>Ship To</Text>
              <br />

              {data.shipping_contact_person && (
                <>
                  <Text>
                    Contact Person : +{data.shipping_contact_person}
                  </Text>
                  <br />
                </>
              )}

              <Text className="wrap-text">
                Address : {data.shipping_address}
              </Text>
              {data.shipping_po_box && (
                <>
                  <Text>
                    Po Box : {data.shipping_po_box}
                  </Text>
                  <br />
                </>
              )}

              {data.shipping_contact_no && (
                <>
                  <Text>
                    Contact No : +{data.shipping_contact_no}
                  </Text>
                  <br />
                </>
              )}
            </>
          )}
        </Col>
        <Col flex="320px" className="invoice-title">
          <Title level={2}>SERVICE EXPENSE</Title>
          <Text strong>Voucher No: {data.service_ex_voucher_no}</Text>
          <br />
          <Text>Expense Date: {formatToCompanyTimezone(data.created_date)?.split(" ")[0]}</Text>
          <br />
          <Text>Expense By: {data.full_name?.split(" ")[0]}</Text>
          <br />
          <Text className="wrap-text">Address : {institution?.street_address}</Text>
          {institution?.phone_no && <Text>Contact No : &nbsp; +{institution?.phone_no}</Text>}
          <br />
          {institution?.vat_license && <><Text>
            {institution?.country?.trim().toLowerCase() === "united arab emirates"
              ? "TRN No: "
              : "Tax Reg No: "}{" "}
            {institution?.vat_license}
          </Text><br /></>}
          {data.licence_no && <Text>License No : {data.licence_no}</Text>}
        </Col>
      </Row>


      {/* Items Table */}
      <Table
        className="invoice-items"
        dataSource={items}
        columns={columns}
        pagination={false}
        rowKey="pur_o_d_id"
        size="small"
        summary={() => {
          let colspanValue = 4;
          if (isIndividual) {
            colspanValue = 7;
            if (isGSTDisabled) {
              colspanValue = 6;
            }
            // return (
            //   <Table.Summary.Row>
            //     {/* <Table.Summary.Cell colSpan={5} align="right">
            //       <b>Grand Total</b>
            //     </Table.Summary.Cell>
            //     <Table.Summary.Cell align="right">
            //       <b>{grandTotal.toFixed(2)}</b>
            //     </Table.Summary.Cell> */}
            //   </Table.Summary.Row>
            // );
          }
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={colspanValue} align="right">
                  Subtotal
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.sub_total || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={colspanValue} align="right">
                  Discount Amount
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {Number(data.total_discount || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>

              {isIndiaGst ? (
                <>
                  {data.place_of_supply_type == 'intra' && isIndiaGst && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={colspanValue} align="right">
                        CGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormatTax(data.cgst_amount || 0)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>

                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={colspanValue} align="right">
                        SGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormatTax(data.sgst_amount || 0)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                  {data.place_of_supply_type == 'inter' && isIndiaGst && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={colspanValue} align="right">
                        IGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormatTax(data.igst_amount || 0)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                  {data.gst_calculated == 'no' && <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={colspanValue} align="right">
                        IGST
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        {numberFormatTax(data.igst_amount || 0)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>}

                </>
              ) : (
                !isIndia && (
                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={colspanValue} align="right">
                      {taxLabel}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      {Number(data.total_tax || 0).toFixed(2)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                ))}

              {/* <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3} align="right">
                  <b>Grand Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <b>{Number(grandTotal).toFixed(2)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row> */}
            </>
          );
        }}
      />

      {/* Footer */}
      <Divider />
      <Row>
        <Col span={16}>
          {/* <Text>Invoice Due : {numberFormat(data.due_total || 0)}</Text>
    <br />
    <Text>
      Current Customer Due : {numberFormat(data.due_amount || 0)}
    </Text> */}
          {/* 🔽 Payment Breakdown */}
          {!printMode && data?.trans && data.trans.length > 0 && (
            <Row gutter={[16, 8]} style={{ marginTop: 12 }}>
              <Col span={10}>
                <Divider orientation="left" plain style={{ margin: "8px 0" }}>
                  Payment Breakdown
                </Divider>
                <Table
                  size="small"
                  bordered
                  pagination={false}
                  style={{ width: "100%" }}  // ✅ take full col width
                  rowKey={(_, index) => index}
                  dataSource={data.trans.map((tran, index) => ({
                    key: index,
                    index: index + 1,
                    account: tran.from_acc_name || "N/A",
                    amount: parseFloat(
                      data?.conversion_rate && data.conversion_rate !== 0
                        ? tran.tran_amount * data.conversion_rate
                        : tran.tran_amount
                    ).toFixed(2),
                  }))}
                  columns={[
                    {
                      title: "#",
                      dataIndex: "index",
                      width: 50,
                    },
                    {
                      title: "Cash / Account",
                      dataIndex: "account",
                      // ellipsis: true,
                      onCell: () => ({
                        style: { minWidth: 120 },   // ✅ enforce minWidth
                      }),
                    },
                    {
                      title: "Amount",
                      dataIndex: "amount",
                      align: "right",
                      width: 120,
                      render: (val) => numberFormat(val),
                    },
                  ]}

                />
              </Col>
              <Col span={2}></Col>
            </Row>
          )}
        </Col>

        <Col span={8} style={{ textAlign: "right" }}>
          <div>
            {/* Quantity */}
            <div style={{ display: "flex", textAlign: "left" }}>
              <Text>Quantity Total :</Text>
              <Text>
                ({items.reduce((sum, d) => sum + (Number(d.item_qty) || 0), 0)})
              </Text>
            </div>

            {/* Sub Total */}
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Text>Sub Total : </Text>
        <Text>{numberFormat(isIndividual ? grandTotal : data.sub_total || 0)}</Text>
      </div> */}

            {/* Grand Total */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Grand Total ({institution?.currency}): </Text>
              <Text strong>{numberFormat(grandTotal)}</Text>
            </div>

            {/* Paid */}
            <div
              style={{
                borderTop: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 4,
                marginTop: 4,
              }}
            >
              <Text strong>Paid ({institution?.currency}): </Text>
              <Text strong>{numberFormat(data.paid_total || 0)}</Text>
            </div>

            {/* Due */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 2,
              }}
            >
              <Text strong>Due ({institution?.currency}): </Text>
              <Text strong>{numberFormat(data.due_total || 0)}</Text>
            </div>
          </div>
        </Col>
      </Row>

      <Divider />
      <Row>
        <Col span={24}>
          <Text>
            In Word of Grand Total :{" "}
            {convertNumberToWords(grandTotal, data?.currency || institution?.currency)}
          </Text>
          <br />
          <Text>Description : {data.narration || "-"}</Text>
        </Col>
      </Row>

      {(showStamp || showSignature) && (
        <div className="invoice-footer-section">
          <div className="footer-right-group">
            {showStamp && institution?.stamp && (
              <div className="stamp-block">
                <img src={institution.stamp} alt="Stamp" />
              </div>
            )}

            {showSignature && institution?.signature && (
              <div className="signature-block">
                <img src={institution.signature} alt="Signature" />
                <div className="sign-line-text">Authorized Signature</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceExpenseVoucherBody;
